




















import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class FeatureList extends Vue {
    @Prop()
    features!: string[];

    @Prop()
    disabledFeatures!: string[]

    private get tickIcon(): any {
        return { iconName: 'check-circle', prefix: 'fas', size: '1x'};
    }

    private get crossIcon(): any {
        return { iconName: 'times-circle', prefix: 'fas', size: '1x'};
    }
}
